













































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { FilteredEvent, FilteredEventLocation } from "@/store/eventqueue/types";

const Mobile = namespace("mobile");

@Component({})
export default class MobileEventQueueItem extends Vue  {
 
    @Prop()
    public eventItem: FilteredEvent;

	@Mobile.Mutation setFocalPoint: any;

	public showOnMap(eventQueueItem: FilteredEvent) {

		let firstValidLocation = eventQueueItem.locations
			.firstOrDefault((location: FilteredEventLocation) => location.location != null)

		const position = this.parseLocationToLatLng(firstValidLocation.location);
		this.setFocalPoint(position);
	}

	public parseLocationToLatLng(location: string): google.maps.LatLng {
		if (!location) {
			return new google.maps.LatLng(0, 0);
		}

		// Split the location string into a proper Google LatLng object
		let latlng = location.split(",");
		if (latlng.length < 2) {
			latlng = location.split(" ");
		}
		return new google.maps.LatLng(parseFloat(latlng[0]), parseFloat(latlng[1]));
	}

	private showShowOnMap (eventQueueItem: FilteredEvent) : boolean {
		return eventQueueItem.locations.some(c => c.location)
	}
}
